import http from "@/utils/request";

const heZhuApi = {
  list: (data) =>
    http.sendRequest({
      METHOD_NAME: "customsHeZhu.pageQuery",
      SECURITY_TYPE: "UserLogin",
      data,
      ERROR_CODE: {},
    }),
  load: (data) =>
    http.sendRequest({
      METHOD_NAME: "customsHeZhu.load",
      SECURITY_TYPE: "UserLogin",
      data,
      ERROR_CODE: {},
    }),
  delete: (data) =>
    http.sendRequest({
      METHOD_NAME: "customsHeZhu.delete",
      SECURITY_TYPE: "UserLogin",
      data,
      ERROR_CODE: {},
    }),
  declare: (data) =>
    http.sendRequest({
      METHOD_NAME: "customsHeZhu.declare",
      SECURITY_TYPE: "UserLogin",
      data,
      ERROR_CODE: {},
    }),
  importPreview: (data) =>
    http.sendRequest({
      METHOD_NAME: "customsDeclarePurchase.importHeZhuOrderPreview",
      SECURITY_TYPE: "UserLogin",
      data,
      ERROR_CODE: {},
    }),
  batchImport: (data) =>
    http.sendRequest({
      METHOD_NAME: "customsDeclarePurchase.importHeZhuOrder",
      SECURITY_TYPE: "UserLogin",
      data,
      ERROR_CODE: {},
    }),
  manualDeclareSuccess: (data) =>
    http.sendRequest({
      METHOD_NAME: "customsHeZhu.manualDeclareSuccess",
      SECURITY_TYPE: "UserLogin",
      data,
      ERROR_CODE: {},
    }),
  create: (data) =>
    http.sendRequest({
      METHOD_NAME: "customsHeZhu.createByPurchaseOrder",
      SECURITY_TYPE: "UserLogin",
      data,
      ERROR_CODE: {},
    }),
  createByStockoutOrder: (data) =>
    http.sendRequest({
      METHOD_NAME: "customsHeZhu.createByToBStockoutOrder",
      SECURITY_TYPE: "UserLogin",
      data,
      ERROR_CODE: {},
    }),
  createByReturnDeclareOrder: (data) =>
    http.sendRequest({
      METHOD_NAME: "customsHeZhu.createByReturnOrder",
      SECURITY_TYPE: "UserLogin",
      data,
      ERROR_CODE: {},
    }),
  eCommercePageQuery: (data) =>
    http.sendRequest({
      METHOD_NAME: "customsHeZhu.ecommercePageQuery",
      SECURITY_TYPE: "UserLogin",
      data,
      ERROR_CODE: {},
    }),
  createECommerceHead: (data) =>
    http.sendRequest({
      METHOD_NAME: "customsHeZhu.createECommerceHead",
      SECURITY_TYPE: "UserLogin",
      data,
      ERROR_CODE: {},
    }),
  createECommerceBody: (data) =>
    http.sendRequest({
      METHOD_NAME: "customsHeZhu.createECommerceBody",
      SECURITY_TYPE: "UserLogin",
      data,
      ERROR_CODE: {},
    }),
  createCustomECommerceBody: (data) =>
    http.sendRequest({
      METHOD_NAME: "customsHeZhu.createCustomECommerceBody",
      SECURITY_TYPE: "UserLogin",
      data,
      ERROR_CODE: {},
    }),
};

export default heZhuApi;
